import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#e1e5eb'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#e1e5eb',
        backgroundColor: '#e1e5eb',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
    },
    description: {
        width: '40%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    qty: {
        width: '5%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    price: {
        width: '18.33%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    amount: {
        width: '18.33%'
    },
  });

  const InvoiceTableHeader = ({ translate }) => (
    <View style={styles.container}>
        <Text style={styles.description}>{translate('product')}</Text>
        <Text style={styles.qty}>{translate('qty')}</Text>
        <Text style={styles.price}>{translate('exclTax')} (€)</Text>
        <Text style={styles.price}>{translate('inclTax')} (€)</Text>
        <Text style={styles.amount}>{translate('total')} {translate('inclTax')} (€)</Text>
    </View>
  );
  
  export default InvoiceTableHeader